import React, { useState, useContext } from "react";
import { UserContext } from './context/UserContext';
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import requests from "./base";


const AuthCode = () => {
  const { user, addUser, setIsLogged  } = useContext(UserContext);

  

  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = {
      PhoneNumber: user?.MobileNo, // Get the mobile number from the context
      Code: otp,
      Email: user?.Email,
      UserId: user?.UserId,
      CountryID: user?.CountryID,
    };

    try {
      const response = await requests.post("VerifyVendorAuthCode", body);
      
      if (response) {

        addUser({
          MobileNo: user?.MobileNo,
          Email: user?.Email,
          UserId: user?.UserId,
          CountryID: user?.CountryID,
          token: response?.data?.token, // Assuming the response includes a token
        });
        setIsLogged(true);
        swal("Success", "OTP Verified", "success");
        navigate("/"); // Redirect after OTP verification
      }
    } catch (error) {
      
      swal("Failed", "Invalid OTP", "error");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto", paddingTop: "40px" }}>
      <h2>Enter OTP</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <label>OTP</label><br />
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
            placeholder="Enter the OTP"
          />
        </div>

        {/* Hidden fields for additional user data */}
        <input
          type="hidden"
          value={user?.MobileNo} // Use the mobile number from the context
          name="MobileNo"
        />
        <input
          type="hidden"
          value={user?.Email} // Use the email from the context
          name="Email"
        />
        <input
          type="hidden"
          value={user?.CountryID} // Use the CountryID from the context
          name="CountryID"
        />

      <input
          type="hidden"
          value={user?.UserId} // Use the CountryID from the context
          name="UserId"
        />

        <button type="submit">Verify OTP</button>
      </form>
    </div>
  );
};

export default AuthCode;
